import {
  faFileImage,
  faShoppingCart,
  faTrainSubway,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { useLocale } from "../stores/locale";
import { PrimeTabMenu } from "./prime/tab-menu";

export default function Menu() {
  const t = useLocale((state) => state.locale);

  return (
    <div className="bg-blue-400 sticky bottom-0">
      <div className="lg:container">
        <PrimeTabMenu
          className="!bg-blue-400"
          model={[
            {
              label: t.shopping.title,
              url: "/shopping",
              icon: <FontAwesomeIcon icon={faShoppingCart} />,
            },
            {
              label: t.departures.title,
              url: "/departures",
              icon: <FontAwesomeIcon icon={faTrainSubway} />,
            },
            {
              label: t.schoolLunch.title,
              url: "/school-lunch",
              icon: <FontAwesomeIcon icon={faUtensils} />,
            },
            {
              label: t.takk.title,
              url: "/takk",
              icon: <FontAwesomeIcon icon={faFileImage} />,
            },
          ]}
          modelClassName="!rounded-none !bg-transparent !text-white"
          modelLabelClassName="hidden lg:block"
          pt={{
            menu: { className: "!bg-transparent !border-none" },
            menuitem: {
              className: "!border-gray-300 !border-r-2 first:!border-l-2",
            },
          }}
        />
      </div>
    </div>
  );
}
